var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Calendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-calendar",
    d: "M8.167,6A2.174,2.174,0,0,0,6,8.167v7.667A2.174,2.174,0,0,0,8.167,18h7.667A2.174,2.174,0,0,0,18,15.833V8.167A2.174,2.174,0,0,0,15.833,6Zm0,1h7.667A1.159,1.159,0,0,1,17,8.167v.5H7v-.5A1.159,1.159,0,0,1,8.167,7ZM7,9.667H17v6.167A1.159,1.159,0,0,1,15.833,17H8.167A1.159,1.159,0,0,1,7,15.833ZM9.167,11a.833.833,0,1,0,.833.833A.833.833,0,0,0,9.167,11ZM12,11a.833.833,0,1,0,.833.833A.833.833,0,0,0,12,11Zm2.833,0a.833.833,0,1,0,.833.833A.833.833,0,0,0,14.833,11ZM9.167,14a.833.833,0,1,0,.833.833A.833.833,0,0,0,9.167,14ZM12,14a.833.833,0,1,0,.833.833A.833.833,0,0,0,12,14Z",
    transform: "translate(-6 -6)",
    fill: "#2A60BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Calendar);
export default __webpack_public_path__ + "static/media/icons8-calendar.010ef1af9d94156d6179dc7e916c6836.svg";
export { ForwardRef as ReactComponent };